import { Fragment, useContext } from 'react'
import { IntegracionesContext } from '../../../context/integraciones.context'
import SingleNovedad from './Novedad/SingleNovedad'
import { Box, Divider, Typography } from '@mui/material'
import NoNovedades from './NoNovedades'

const ListadoNovedades = () => {
  const { novedades } = useContext(IntegracionesContext)

  if (!novedades.length)
    return (
      <Typography variant="h6">
        <NoNovedades />
      </Typography>
    )

  return (
    <Box display="flex" flexDirection="column" gap={2} bgcolor="#FDFDFE" borderRadius="8px">
      {novedades.map((novedad) => (
        <Fragment key={novedad.productoInterno.idProducto}>
          <SingleNovedad novedad={novedad} />
          <Divider color="black" />
        </Fragment>
      ))}
    </Box>
  )
}

export default ListadoNovedades
